import {Action} from '@ngrx/store';
import {UserModel} from '../models/user.model';

export enum AuthActionTypes {
    LOGIN = '[Auth Feature] Emit to login',
    LOGOUT = '[Auth Feature] Emit to logout',
    LOGOUT_SUUMO = '[Auth Feature] Emit to logout suumo',
    REGISTER_USER = '[Auth Feature] Emit to register a new user',
    LOAD_CURRENT_USER = '[Auth Feature] Emit to load the current user',
    RELOAD_CURRENT_USER = '[Auth Feature] Emit to reload the current user',
    CURRENT_USER_LOADED = '[Auth Feature] Emitted after a user has been loaded'
}

export class LoginAction implements Action {
    readonly type = AuthActionTypes.LOGIN;

    constructor(public payload: { authToken: string , pathToken: string | null}) {
    }
}

export class LogoutAction implements Action {
    readonly type = AuthActionTypes.LOGOUT;
}

export class LogoutSuumoAction implements Action {
    readonly type = AuthActionTypes.LOGOUT_SUUMO;
}

export class RegisterUserAction implements Action {
    readonly type = AuthActionTypes.REGISTER_USER;

    constructor(public payload: { authToken: string }) {
    }
}

export class LoadCurrentUserAction implements Action {
    readonly type = AuthActionTypes.LOAD_CURRENT_USER;

    constructor(public payload: {token?: string | null}) {
    }

}

export class ReloadCurrentUserAction implements Action {
    readonly type = AuthActionTypes.RELOAD_CURRENT_USER;

    constructor(public payload: {token?: string | null}) {
    }
}

export class CurrentUserLoadedAction implements Action {
    readonly type = AuthActionTypes.CURRENT_USER_LOADED;

    constructor(public payload: { user: UserModel }) {
    }
}

export type AuthActions = LoginAction |
    LogoutAction |
    RegisterUserAction |
    LoadCurrentUserAction |
    ReloadCurrentUserAction |
    CurrentUserLoadedAction;
